(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('hrrdc-');
        $sessionStorageProvider.setKeyPrefix('hrrdc-');
    }
})();
